import React from "react";
import IconButton from "@material-ui/core/IconButton";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { makeStyles } from "@material-ui/core";
import { useCallback } from "react";
import { storage } from "../../firebase";
import { useDispatch } from "react-redux";
import ImagePreview from "./ImagePreview";
import {
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { fb } from "../../firebase";
import {
  showLoadingAction,
  hideLoadingAction,
} from "../../reducks/loading/actions";

const useStyles = makeStyles({
  icon: {
    height: 48,
    width: 48,
  },
});

const ImageArea = (props) => {
  const classes = useStyles();
  const images = props.images;
  const dispatch = useDispatch();

  const deleteImage = useCallback(
    async (id) => {
      const ret = window.confirm("この画像を削除しますか？");
      if (!ret) {
        return false;
      } else {
        const newImages = images.filter((image) => image.id !== id);
        props.setImages(newImages);

        // 新しいAPIを使用してファイルを削除
        //const imageRef = storageRef(storage, 'images/' + id);
        //return deleteObject(imageRef);
      }
    },
    [images]
  );

  const uploadImage = useCallback(
    (event) => {
      dispatch(showLoadingAction("アップロード中..."));
      const file = event.target.files;
      //let blob = new Blob(file, { type: "image/jpeg" });
      let blob = new Blob(file, { type: "image/*" });

      // Generate random 16 digits strings
      const S =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      const N = 16;
      const fileName = Array.from(crypto.getRandomValues(new Uint32Array(N)))
        .map((n) => S[n % S.length])
        .join("");

      const uploadRef = storageRef(storage, "images/" + fileName);
      const uploadTask = uploadBytes(uploadRef, blob);

      uploadTask
        .then((snapshot) => {
          // Handle successful uploads on complete
          getDownloadURL(snapshot.ref).then((downloadURL) => {
            const newImage = { id: fileName, path: downloadURL };
            props.setImages((prevState) => [...prevState, newImage]);
            dispatch(hideLoadingAction());
          });
        })
        .catch(() => {
          dispatch(hideLoadingAction());
        });
    },
    [props.setImages]
  );

  return (
    <div>
      <div className="p-grid__list-images">
        {props.images.length > 0 &&
          props.images.map((image) => (
            <ImagePreview
              delete={deleteImage}
              id={image.id}
              path={image.path}
              key={image.id}
            />
          ))}
      </div>
      <div className="u-text-right">
        <span>商品画像を登録する</span>
        <IconButton className={classes.icon}>
          <label>
            <AddPhotoAlternateIcon />
            <input
              className="u-display-none"
              type="file"
              id="image"
              accept=".jpeg,.jpg,.png"
              onChange={(e) => uploadImage(e)}
            />
          </label>
        </IconButton>
      </div>
    </div>
  );
};

export default ImageArea;
